'use es6';

import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ReportsContainer from './containers/ReportsContainer';
import EmailReportPreviewContainer from './containers/EmailReportPreviewContainer';
import RestoreReportsContainer from './containers/RestoreReportsContainer';
import TagManagerContainer from './containers/TagManagerContainer';
import { ANALYTICS_SUITE_IDS } from './constants/templates';
import { OLD_ACTIVITIES_AND_LEADS_SUB_APPS_TO_NEW } from './utils/reportingIAUtils';
import { encodeParentheses } from './utils/urls';
import { getIsUngatedForActivitiesAndLeadsNewIA, getIsUngatedToSmartLibrary } from './selectors/gatesSelector';
import { SmartLibraryContainer } from './SmartLibrary/SmartLibraryContainer';
import { AssetViewerContainer } from './SmartLibrary/containers/AssetViewerContainer';
import { TemplateViewerContainer } from './SmartLibrary/containers/TemplateViewerContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getActivitiesAndLeadsGatedRedirects = isUngatedForActivitiesAndLeadsNewIA => {
  if (!isUngatedForActivitiesAndLeadsNewIA) return null;
  return Object.keys(OLD_ACTIVITIES_AND_LEADS_SUB_APPS_TO_NEW).map(subAppKey => {
    const newSubAppInfo = OLD_ACTIVITIES_AND_LEADS_SUB_APPS_TO_NEW[subAppKey];
    let encodedSearch = encodeParentheses(window.location.search);
    if (newSubAppInfo.tabKey) {
      const searchParams = new URLSearchParams(encodedSearch);
      if (newSubAppInfo.tabKey) {
        searchParams.set('tab', newSubAppInfo.tabKey);
        encodedSearch = `?${searchParams.toString()}`;
      }
    }
    return /*#__PURE__*/_jsx(Redirect, {
      exact: true,
      from: `/templates/${ANALYTICS_SUITE_IDS.SALES}/${subAppKey}`,
      to: `/templates/${ANALYTICS_SUITE_IDS.SALES}/${newSubAppInfo.newSubApp}${encodedSearch}`
    }, `template-key-to-${subAppKey}`);
  });
};
const Routes = () => {
  const isUngatedForActivitiesAndLeadsNewIA = useSelector(getIsUngatedForActivitiesAndLeadsNewIA);
  const isUngatedToSmartLibrary = useSelector(getIsUngatedToSmartLibrary);
  if (isUngatedToSmartLibrary) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/report/:reportId",
        exact: true,
        component: AssetViewerContainer
      }), getActivitiesAndLeadsGatedRedirects(isUngatedForActivitiesAndLeadsNewIA), /*#__PURE__*/_jsx(Redirect, {
        exact: true,
        from: "/templates/:suiteId/:subAppKey",
        to: "/templates/:subAppKey"
      }), /*#__PURE__*/_jsx(Route, {
        path: "/templates/:subAppKey",
        exact: true,
        component: TemplateViewerContainer
      }), /*#__PURE__*/_jsx(Route, {
        path: "/",
        component: SmartLibraryContainer
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/export/:reportId",
      exact: true,
      component: EmailReportPreviewContainer
    }), getActivitiesAndLeadsGatedRedirects(isUngatedForActivitiesAndLeadsNewIA), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/templates/:collectionId/:templateId?",
      component: ReportsContainer
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/collections/:collectionId/:categoryId?",
      component: ReportsContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: "/restore",
      exact: true,
      component: RestoreReportsContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: "/tags",
      exact: true,
      component: TagManagerContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: "/",
      exact: true,
      component: ReportsContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: "/:reportId",
      component: ReportsContainer
    })]
  });
};
export default Routes;